var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInpreparation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ordenes---MovilDash",
    transform: "translate(-328.000000, -346.000000)",
    fill: "#585858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(328.000000, 346.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6421037,7.5114099 L10.262915,3.59627024 C10.2891206,2.67563123 9.68031943,1.57400668 8.62398406,0.805017762 C7.19999942,-0.231651008 5.50386802,-0.272771915 4.83937525,0.714656211 C4.17387509,1.70208427 4.79023765,3.3440441 6.21422245,4.38071286 C7.27232056,5.15048756 8.47657125,5.3678795 9.29981609,5.02686259 L14.6774929,8.94095491 C15.0582472,9.21806373 15.5816256,9.12246413 15.847221,8.72696843 C16.1145799,8.3314731 16.0210941,7.78747102 15.6421021,7.5114099 L15.6421037,7.5114099 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45835079,7.3339844 C3.81543516,7.3339844 2.21715223,7.50210443 0.68555112,7.83692851 C0.640451118,7.84358748 0.282285763,7.90283901 0.120918235,8.12856488 C0.0503692139,8.22732066 0.0263885979,8.34143212 0.0497506996,8.46778043 C0.0848693985,8.65753267 0.319571639,8.76976896 0.451160525,8.81851534 C0.412325963,9.18641423 0.241831749,10.7615589 0.122235538,11.2608194 C0.0529991066,11.5497195 -0.0456288103,12.2335563 0.0235273543,12.9641879 C0.108155954,13.8572942 0.419672661,14.5550042 0.924819075,14.9834171 L1.06591708,15.245433 L1.07659251,15.2557754 C1.11016726,15.2883813 1.88637164,16.0001164 5.32777238,16.0001164 C5.59070954,16.0001164 5.86935001,15.9959645 6.16423802,15.9870283 C8.50608043,15.9160952 9.95614564,15.6726599 10.2473971,15.3016227 C10.2849951,15.2537374 10.2972949,15.211956 10.3000805,15.1820959 L10.3425502,15.0787956 C10.4315137,15.0087236 10.7536303,14.7303282 11.0251507,14.1801302 C11.5401983,13.1363835 11.4641537,11.9394902 11.3096699,11.1192014 C11.0311046,9.63999013 11.0590321,9.05647814 11.0760486,8.90348425 C11.1954892,8.84823203 11.4612874,8.69946696 11.4252383,8.48228476 C11.4191286,8.4455265 11.4185857,8.40939002 11.4179674,8.37436348 C11.4150257,8.20648264 11.3886463,8.07198276 11.0846321,7.99502182 L11.0614257,7.98906125 C10.4936203,7.84367361 9.29775281,7.57805121 7.66752381,7.43313236 C6.92350149,7.36698269 6.18659391,7.3339844 5.45835079,7.3339844",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInpreparation);
export default __webpack_public_path__ + "static/media/inpreparation.4f375dcf94cec3c8bce392cdb890ba12.svg";
export { ForwardRef as ReactComponent };